import {A11yStandardType, Measurement, MeasurementSystem} from "../models/A11yStandard";

// TODO: let the user pick the system once the backend/UI toggle exists (Alex)
export const DISPLAY_MEASUREMENT_SYSTEM: MeasurementSystem = 'metric'

export const getMeasurementValues = (measurement?: Measurement | null): number[] => {
  const value = measurement?.[DISPLAY_MEASUREMENT_SYSTEM]?.value
  if (value === undefined || value === null) {
    return []
  }
  return Array.isArray(value) ? value : [value]
}

export const getMeasurementUnit = (measurement?: Measurement | null): string => {
  return measurement?.[DISPLAY_MEASUREMENT_SYSTEM]?.unit ?? ''
}

export const replaceText = (
  text: string,
  itemTitle: string = '',
  unitTitle: string = '',
  standardTitle: string = '',
  measurement?: Measurement | null
) => {
  if (!text) {
    return text
  }

  const values = getMeasurementValues(measurement)

  return text
    .replace(/{item__title}/g, itemTitle.toLowerCase())
    .replace(/{unit__title}/g, unitTitle.toLowerCase())
    .replace(/{standard__title}/g, standardTitle.toLowerCase())
    // {measurement__value} is a legacy alias for {measurement__value__0}
    .replace(/{measurement__value(?:__(\d+))?}/g, (_match, index?: string) => {
      const value = values[index ? Number(index) : 0]
      return value === undefined ? '' : String(value)
    })
    .replace(/{measurement__unit}/g, getMeasurementUnit(measurement))
}

/**
 * Flat map of attribute key (or `<attribute>__<answer>` key) -> measurement, built from the questionnaire.
 * Accessibilities only reference an attribute by key, and their titles are
 * inherited from that attribute, so this is how they get their measurement.
 * Attribute keys are unique across the questionnaire, so a flat map is enough.
 */
export const getMeasurementsByAttribute = (standards: A11yStandardType[]): Record<string, Measurement> => {
  const measurements: Record<string, Measurement> = {}

  standards.forEach((standard) => {
    standard.values?.forEach((a11yUnit) => {
      a11yUnit.values?.forEach((a11yItem) => {
        a11yItem.values?.forEach((a11yAttribute) => {
          if (a11yAttribute.measurement) {
            measurements[a11yAttribute.key] = a11yAttribute.measurement
          }
          // for choice attributes an accessibility references `<attribute>__<answer>` (e.g. door_width__gte_90_cm),
          // and the answer carries its own measurement
          a11yAttribute.values?.forEach((a11yAttributeValue) => {
            if (a11yAttributeValue.measurement) {
              measurements[`${a11yAttribute.key}__${a11yAttributeValue.key}`] = a11yAttributeValue.measurement
            }
          })
        })
      })
    })
  })

  return measurements
}
